import { UserProfile } from '__generated__/GQL';
import { ApplicantType } from 'features/Onboarding/types';

import { VerificationStatus } from '../../Verification/lib/steps/types';

const getModuleStatus = ({
  applicantType,
  userProfile,
}: {
  userProfile: Pick<UserProfile, 'street' | 'zip' | 'city' | 'country'>;
  applicantType: ApplicantType;
}) => {
  // Mandatees don't have to fill personal address
  // See https://github.com/shinetools/web-app/pull/8163
  if (applicantType === ApplicantType.Mandatee) {
    return VerificationStatus.Irrelevant;
  }

  const { city, country, street, zip } = userProfile;

  return street && zip && city && country
    ? VerificationStatus.Completed
    : VerificationStatus.ToDo;
};

export default getModuleStatus;
